import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useEffect, useState } from "react";
import { apiUrl } from "../../constants";
import { QUERY_CHECKOUT_PAYMENT_GATEWAYS } from "../graphql/checkoutManualTransfer";
export var fetchCheckoutPaymentGateways = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(checkoutToken) {
    var token, headers, response, payload, gateways;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = localStorage.getItem("token");
            headers = {
              "Content-Type": "application/json"
            };

            if (token) {
              headers.Authorization = "JWT ".concat(token);
            }

            _context.next = 5;
            return fetch(apiUrl, {
              method: "POST",
              headers: headers,
              body: JSON.stringify({
                query: QUERY_CHECKOUT_PAYMENT_GATEWAYS,
                variables: {
                  token: checkoutToken
                }
              })
            });

          case 5:
            response = _context.sent;
            _context.next = 8;
            return response.json();

          case 8:
            payload = _context.sent;
            gateways = payload.data && payload.data.checkout && payload.data.checkout.availablePaymentGateways;
            return _context.abrupt("return", gateways || []);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCheckoutPaymentGateways(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var useCheckoutPaymentGateways = function useCheckoutPaymentGateways(checkoutToken) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      paymentGateways = _useState2[0],
      setPaymentGateways = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    if (!checkoutToken) {
      setPaymentGateways([]);
      return undefined;
    }

    var cancelled = false;
    setLoading(true);
    fetchCheckoutPaymentGateways(checkoutToken).then(function (gateways) {
      if (!cancelled) {
        setPaymentGateways(gateways);
      }
    }).catch(function () {
      if (!cancelled) {
        setPaymentGateways([]);
      }
    }).finally(function () {
      if (!cancelled) {
        setLoading(false);
      }
    });
    return function () {
      cancelled = true;
    };
  }, [checkoutToken]);
  return {
    paymentGateways: paymentGateways,
    loading: loading
  };
};